import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { LoaderProvider } from "../src/interceptor/LoaderContext";
import Loader from "../src/interceptor/Loader";
import Login from "./components/Auth/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import ProtectedRoute from "./components/Shared/ProtectedRoute";
import ScanWebsite from "./components/Dashboard/ScanWebsite";
import OpenTicket from "./components/Dashboard/OpenTicket";
import Register from "./components/Registration/Register";
import ManageAgents from "./components/Organisation/ManageAgents";
import ManageOrganisation from "./components/Admin/ManageOrganisation";
import Layout from "./Layout";
import AddAgents from "./components/Organisation/AddAgent";
import PageNotFound from "./PageNotFound";
import ROLES from "./components/Utils/Roles";
import OrgSettings from "./components/Organisation/OrgSettings";
import AgentTickets from "./components/Agent/AgentTickets";
import AllTicket from "./components/Organisation/AllTickets";
import NewTicket from "./components/Organisation/NewTicket";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import the CSS file
import NotificationService from "../src/components/Utils/NotificationService"; // Import the notification service
import ClientTicket from "./components/ClientsView/ClientTicket";
import ProfilePage from "./components/Dashboard/ProfilePage";
import DisplaySubsComponent from "./subscription/Display";
import OrganizationDetails from "./components/Admin/OrganisationDetails";
import Chat from "./components/Organisation/Chat";
import ClientsList from "./components/ClientsDisplay/ClientsList";
import ValidateEmail from "./components/validate/ValidateEmail";
import EmailValidatedSuccess from "./components/validate/EmailValidatedSuccess";
import EmailValidatedFailure from "./components/validate/EmailValidatedFailure";
import Home from "./Home";
import ForgotPassword from "./components/Registration/ForgotPassword";
import ResetPassword from "./components/Registration/ResetPassword";
import ScanFile from "./components/Organisation/ScanFile";
import Plans from "./components/Organisation/Plans";
import SetupPage from "./components/Organisation/SetupPage";
import TabsKnowledgeCentre from "./components/Organisation/TabsKnowledgeCentre";
import HtmlGuide from "./components/Organisation/Integration/HtmlGuide";
import ReactGuide from "./components/Organisation/Integration/ReactGuide";
import GoDaddyGuide from "./components/Organisation/Integration/GoDaddyGuide";
import HostingerGuide from "./components/Organisation/Integration/HostingerGuide";
import JoomlaGuide from "./components/Organisation/Integration/JoomlaGuide";
import LaravelGuide from "./components/Organisation/Integration/LaravelGuide";
import ShopifyGuide from "./components/Organisation/Integration/ShopifyGuide";
import WixGuide from "./components/Organisation/Integration/WixGuide";
import WordPressGuide from "./components/Organisation/Integration/WordPressGuide";
import WordPressElementorGuide from "./components/Organisation/Integration/WordPressElementorGuide";
import IntegrationsList from "./components/Organisation/Integration/IntegrationsList";




const App = () => {
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.role) {
      setUserType(user.role);
    }
    setLoading(false);
  }, []);

  const ProtectedRouteWrapper = ({ children, allowedRoles }) => {
    if (loading) {
      return <Loader />;
    }
    if (!userType) {
      return <Navigate to="/login" />;
    }
    if (!allowedRoles.includes(userType)) {
      return <Navigate to="/404" />;
    }
    return children;
  };

  return (
    <LoaderProvider>
      <Loader />
      <Router>
        <Layout userType={userType}>
          <div className="d-flex min-vh-87">
            <main className="flex-grow-1">
              <Routes>
              <Route
                path="/dashboard"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.AGENT, ROLES.ADMIN, ROLES.ORGANIZATION]}><Dashboard /></ProtectedRouteWrapper>}
              />
               <Route
                path="/forgot-password"
                element={<ForgotPassword />}
              />
              <Route
                path="/reset-password"
                element={<ResetPassword />}
              />
              <Route
                path="/profile"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.AGENT, ROLES.ADMIN, ROLES.ORGANIZATION]}><ProfilePage /></ProtectedRouteWrapper>}
              />
              <Route path="/login" element={<Login setUserType={setUserType} />} />
              <Route path="/" element={<Home setUserType={setUserType} />} />

              <Route
                path="/scan-website"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.AGENT]}><ScanWebsite /></ProtectedRouteWrapper>}
              />
              <Route
                path="/chats"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.AGENT,ROLES.ORGANIZATION]}><OpenTicket /></ProtectedRouteWrapper>}
              />
              <Route
                path="/chat"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.AGENT,ROLES.ORGANIZATION]}><Chat /></ProtectedRouteWrapper>}
              />
              <Route path="/register" element={<Register />} />
              <Route
                path="/manage-agents"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION]}><ManageAgents /></ProtectedRouteWrapper>}
              />
              <Route
                path="/manage-organisation"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ADMIN]}><ManageOrganisation /></ProtectedRouteWrapper>}
              />
              <Route
                path="/add-agent"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION]}><AddAgents /></ProtectedRouteWrapper>}
              />
              <Route
                path="/chat-settings"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION]}><OrgSettings /></ProtectedRouteWrapper>}
              />
              <Route
                path="/my-tickets"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.AGENT]}><AgentTickets /></ProtectedRouteWrapper>}
              />
              <Route
                path="/all-tickets"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION, ROLES.AGENT]}><AllTicket /></ProtectedRouteWrapper>}
              />
              <Route
                path="/tickets/new"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION, ROLES.AGENT]}><NewTicket /></ProtectedRouteWrapper>}
              />
              {/* <Route
                path="/subscriptions"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION, ROLES.AGENT]}><DisplaySubsComponent /></ProtectedRouteWrapper>}
              /> */}
              <Route path="/chatbot-setup" element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION, ROLES.AGENT]}><SetupPage></SetupPage></ProtectedRouteWrapper>}
              ></Route>
              <Route
                path="/subscriptions"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION, ROLES.AGENT]}><Plans /></ProtectedRouteWrapper>}
              />
              <Route
                path="/manage-organisation/:id"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ADMIN]}><OrganizationDetails /></ProtectedRouteWrapper>}
              />
              <Route
                path="/contacts"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION, ROLES.AGENT]}><ClientsList /></ProtectedRouteWrapper>}
              />
              <Route
                path="/knowledge-center"
                element={<ProtectedRouteWrapper allowedRoles={[ROLES.ORGANIZATION]}><TabsKnowledgeCentre /></ProtectedRouteWrapper>}
              />
              <Route
                path="/ticket-conversations/:encodeData"
                element={<ClientTicket />}
              />
              <Route
                path="/html-guide"
                element={<HtmlGuide />}
              />
              <Route
                path="/react-guide"
                element={<ReactGuide />}
              />
              <Route
                path="/godaddy-guide"
                element={<GoDaddyGuide />}
              />
              <Route
                path="/hostinger-guide"
                element={<HostingerGuide />}
              />
              <Route
                path="/joomla-guide"
                element={<JoomlaGuide />}
              />
              <Route
                path="/laravel-guide"
                element={<LaravelGuide />}
              />
              <Route
                path="/shopify-guide"
                element={<ShopifyGuide />}
              />
              <Route
                path="/wix-guide"
                element={<WixGuide />}
              />
              <Route
                path="/wordpress-guide"
                element={<WordPressGuide />}
              />
              <Route
                path="/wordpress-elementor-guide"
                element={<WordPressElementorGuide />}
              />
              <Route path="/validate-email" element={<ValidateEmail />} />
              <Route path="/validate-email-success" element={<EmailValidatedSuccess />} />
              <Route path="/validate-email-failure" element={<EmailValidatedFailure />} />
              <Route path="/integrations" element={<IntegrationsList />} />
              {/* Fallback for unmatched routes */}
              <Route path="*" element={<PageNotFound />} />
              </Routes>
              <ToastContainer />
            </main>
          </div>
        </Layout>
      </Router>
    </LoaderProvider>
  );
};

export default App;
